import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const config = useRuntimeConfig()
  
  // 登出狀態標記
  const isSigningOut = ref(false)

  /**
   * 純粹的身份驗證登出邏輯
   * 不再負責清理其他 store 的狀態，由協調層處理
   */
  const signOut = async () => {
    // 防止重複執行登出
    if (isSigningOut.value) return
    
    isSigningOut.value = true
    
    try {
      // 呼叫 API 清除 server 端 httpOnly cookie
      await $fetch('/api/auth/clear-token', { method: 'POST' })
      
      // 清除客戶端 cookie token
      const token = useCookie('token')
      token.value = ''
      
      // 導向登入頁面
      await navigateTo(config.public.GSNurl, { external: true })
    } finally {
      isSigningOut.value = false
    }
  }

  return { signOut, isSigningOut }
})
